export const GET_SEARCH_MOVIES = 'GET_SEARCH_MOVIES'
export const GET_NOW_PLAYING_MOVIES = "GET_NOW_PLAYING_MOVIES"
export const GET_LATEST_MOVIE = 'GET_LATEST_MOVIE'
export const GET_UPCOMING_MOVIES = 'GET_UPCOMING_MOVIES'
export const GET_CURRENT_MOVIE_DETAILS = 'GET_CURRENT_MOVIE_DETAILS'
export const LOADING_UI = "LOADING_UI"